/* global axios */
import ApiClient from './ApiClient';

class SalesTransactionsAPI extends ApiClient {
  constructor() {
    super('sales_transactions', { accountScoped: true });
  }

  history(id) {
    return axios.get(`${this.url}/${id}/history`);
  }

  review(id) {
    return axios.get(`${this.url}/${id}/review`);
  }

  reviewCatalog(id) {
    return axios.get(`${this.url}/${id}/review_catalog`);
  }

  propertyCatalog(id) {
    return axios.get(`${this.url}/${id}/property_catalog`);
  }

  propertyCertificateChecks(id, payload = {}) {
    return axios.post(`${this.url}/${id}/property_certificate_checks`, payload);
  }

  deliveryCatalog(id) {
    return axios.get(`${this.url}/${id}/delivery_catalog`);
  }

  commissionCatalog(id) {
    return axios.get(`${this.url}/${id}/commission_catalog`);
  }

  receiptDraft(id) {
    return axios.get(`${this.url}/${id}/receipt_draft`);
  }

  downloadReceiptDraft(id) {
    return axios.post(
      `${this.url}/${id}/download_receipt_draft`,
      {},
      { responseType: 'blob' }
    );
  }

  deliveryRecipients(id) {
    return axios.get(`${this.url}/${id}/delivery_recipients`);
  }

  updateDeliveryRecipients(id, payload = {}) {
    return axios.patch(`${this.url}/${id}/delivery_recipients`, payload);
  }

  saveDraft(id, profile = {}) {
    return axios.post(`${this.url}/${id}/save_draft`, { profile });
  }

  savePropertyDetail(id, section, profile = {}) {
    return axios.post(`${this.url}/${id}/save_property_detail`, {
      section,
      profile,
    });
  }

  requestReview(id, items, reason = '') {
    return axios.post(`${this.url}/${id}/request_review`, { items, reason });
  }

  resubmitReview(id, profile = {}) {
    return axios.post(`${this.url}/${id}/resubmit_review`, { profile });
  }

  saveReviewChecks(id, payload = {}) {
    return axios.post(`${this.url}/${id}/save_review_checks`, payload);
  }

  deliver(id, profile = {}) {
    return axios.post(`${this.url}/${id}/deliver`, { profile });
  }

  archive(id, reason = '') {
    return axios.post(`${this.url}/${id}/archive`, { reason });
  }

  restore(id) {
    return axios.post(`${this.url}/${id}/restore`);
  }

  finalize(id) {
    return axios.post(`${this.url}/${id}/finalize`);
  }
}

export default new SalesTransactionsAPI();
